import { QueryParams } from '../../types/api/BasicTypes';

export default function hasSelectedFilters(filters: QueryParams): boolean {
  const keys = Object.keys(filters) || [];
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if ((filters[key] as Array<number>)?.length)
      return true;
  }
  return false;
}
